<script>
import { notificationMixins } from "../../mixins/notification";

export default {
  mixins: [notificationMixins],
  data() {
    return {
      polling: null,
    };
  },
  methods: {
    async poll() {
      await this.fetchAndDisplayNotifications();
    },
  },
  created() {
    this.poll();
    this.polling = setInterval(this.poll, 30000);
  },
  beforeDestroy() {
    clearInterval(this.polling);
  },
  render: () => null, // This makes the component non-visible
};
</script>
